/*
 * @see [Documentation](https://nuxt-graphql-middleware.dulnan.net/advanced/templates#operation-hashes)
 */
export const operationHashes = {
  "addConfigurableProductsToCart": "R4D6Eq95oG",
  "addProductsToCart": "ynhFx6-jpz",
  "addProductsToWishlist": "7gJMPK6wOu",
  "addSimpleProductsToCart": "vOzRi3umwD",
  "additionalProductData": "iwPqoxvjMJ",
  "applyCouponToCart": "gI5cQVEdwB",
  "blogDetail": "3RlJCLptAI",
  "blogOverview": "lBNADSPZ_g",
  "brands": "HwuDmUp9Ci",
  "changeCustomerPassword": "rxTRJKS2Zy",
  "checkToken": "xkG4JABSJJ",
  "createCustomer": "apWrLXYzJB",
  "createCustomerAddress": "8z_b7WtDp8",
  "createEmptyCart": "o1rQ4cxALE",
  "customer": "LR3lZrzl0V",
  "customerServiceDetailPage": "bhOcJhY58Q",
  "customerServicePage": "pP5o7_OW9g",
  "deleteCustomerAddress": "Mne9mPdrvY",
  "esProductListCount": "8gpCCKKZMb",
  "esProducts": "LL8KjKAr8W",
  "esProductsByArticleCode": "UlJXkJnRAU",
  "esUrl": "NTEZG28TOR",
  "esUrlsGlobal": "1hp-bMnDej",
  "getAddressData": "W2oh9llt6n",
  "getCartStatus": "k3OWppLDEv",
  "getCartStoreStock": "v4VfW95OYO",
  "getCustomerCart": "KM1343LUIF",
  "getGiftwrappingProduct": "TAA809cGB9",
  "getGuestCart": "HExuKFvpOG",
  "gtmOrder": "Q2GT53W6dd",
  "layout": "Qyzl607EJ6",
  "login": "_ePma2Id0O",
  "logout": "iCh4bwb3uy",
  "mergeCarts": "d7JGn8sWsO",
  "order": "esB1wUxyZs",
  "orders": "DKr1LQTXVP",
  "page": "5m1Kn3fqeT",
  "pageNoCache": "oNtleMs5Cm",
  "pdp": "PVdArQ3za7",
  "pdpDynamicContent": "uXe0hxpWMb",
  "pdpFixedContent": "MOne5WSy0L",
  "placeOrder": "fYBe0-xpOD",
  "plp": "xHmJ_VPIEz",
  "plpPage": "Bxe9qQ-v9K",
  "preAllocateCartStore": "IIP5zEat8E",
  "quickSearch": "fVTRINv3FH",
  "redirectResolver": "KKs2UCMzuo",
  "removeCouponFromCart": "GcoHcp9ATj",
  "removeItemFromCart": "kgIyoxR0H9",
  "removeProductsFromWishlist": "jfnCZ9yyW3",
  "requestPasswordResetEmail": "lnntgs51WM",
  "resetPassword": "IDSxEfEcc0",
  "restoreCart": "_oUCQJwPPW",
  "search": "2wvOXx50Na",
  "setBillingAddressOnCart": "xlrKxN2687",
  "setGuestEmailOnCart": "EqtrLjXR86",
  "setOrderCommentOnCart": "4J5ZCt13Jc",
  "setPaymentMethodOnCart": "xEFsrXsuif",
  "setShippingAddressesOnCart": "3-43yZYUJx",
  "setShippingMethodsOnCart": "9qZQOzwbc4",
  "setStoreAllocationOnCart": "BjomP3k9Vx",
  "stock": "EQuBMwhrPk",
  "storeConfig": "eEzMxVqPPV",
  "storeDetail": "Pjbf9oFhPt",
  "storeSearch": "MZVhvoj7Be",
  "subscribeEmailToNewsletter": "p2m_3Afiay",
  "ttStore": "FoccjuXXQU",
  "updateCartItems": "6np0ulv3jV",
  "updateCustomer": "n-CrHEqanv",
  "updateCustomerAddress": "ehX4lRzEOb",
  "updateCustomerEmail": "A00VtUobhL",
  "wishlistProduct": "2vB5aQHLvr",
  "wishlistProducts": "ejqEWr3VTB"
}